/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `12` - 12 luni
 * * `3` - 3 luni
 * * `6` - 2 luni
 * * `9` - 9 luni
 */
export enum CascoCommonPeriodEnum {
  '_12' = 12,
  '_3' = 3,
  '_6' = 6,
  '_9' = 9,
}
